// ✅ src/services/departmentService.js
import axiosClient from "../api/axiosClient";

// departments by tenant & location (single location)
export const getDepartmentsByLocation = async (tenant_id, location_id) => {
  const { data } = await axiosClient.get("/tenant/api/departments/list", {
    params: { tenant_id, location_id },
  });
  return data; // { success, data: [ {id,name,...}, ... ] }
};
